module.exports = __webpack_public_path__ + "upload-big.svg?c4d0681206f99f4df85ff7260a317880";